// src/index.ts
import { ListItem } from "@tiptap/extension-list";
import { ListItem as ListItem2 } from "@tiptap/extension-list";
var index_default = ListItem;
export {
  ListItem2 as ListItem,
  index_default as default
};
//# sourceMappingURL=index.js.map